import type { GlobalCollectionId } from '#layers/data-model';
import type { CollectionListingDrawerProps } from '~/components/Collection/CollectionListingDrawer.vue';
import { useOverlay } from '@nuxt/ui/composables';
import CollectionListingDrawer from '~/components/Collection/CollectionListingDrawer.vue';

export function useItemSelectOverlay(collectionId: GlobalCollectionId, props?: Partial<CollectionListingDrawerProps>) {
	const {
		selectionMode = 'single',
	} = props ?? {};

	return useOverlay().create(CollectionListingDrawer, {
		props: {
			collectionId,
			selectionMode,
			...props,
		},
	});
}
